import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKidsTeens = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#kids-teens_svg__a)">
      <path
        fill="#263E6A"
        d="M6.45 16.5c-.8 0-1.45.65-1.45 1.45s.65 1.45 1.45 1.45 1.45-.65 1.45-1.45-.65-1.45-1.45-1.45m0 2.42a.972.972 0 0 1 0-1.94.972.972 0 0 1 0 1.94m4.87-10.414c.966 0 1.752-.786 1.752-1.753S12.286 5 11.32 5s-1.753.786-1.753 1.753.787 1.753 1.753 1.753m0-3.026c.701 0 1.272.571 1.272 1.273s-.57 1.273-1.273 1.273a1.274 1.274 0 0 1-1.273-1.273c0-.702.572-1.273 1.273-1.273m5 8.895h-.001l-1.533-.06a.26.26 0 0 1-.231-.163l-.356-.896a12 12 0 0 0-.062-1.51 13 13 0 0 0-.133-.678l1.486 1.028a.847.847 0 0 0 1.177-.226.85.85 0 0 0-.222-1.181L13.703 8.81c-.18-.124-.52-.139-.656-.12l-1.366.218a1.6 1.6 0 0 0-.637.234l-2.291 1.441a.85.85 0 0 0-.314 1.16.846.846 0 0 0 1.152.317l.015-.008 1.292-.804c.165.194.289.424.363.676.157.47-.008 1.352-.09 1.678l-1.704 3.784a.84.84 0 0 0-.004.647c.085.21.247.373.45.458l.012.005a.846.846 0 0 0 1.109-.45l1.575-3.56.196.43.01.02c.026.044.622 1.056 1.483 1.056l2.012.072a.846.846 0 0 0 .01-1.69m-.002 1.21-2.012-.072c-.485 0-.93-.573-1.07-.806l-.412-.906a.24.24 0 0 0-.219-.14.24.24 0 0 0-.219.142l-1.795 4.059a.36.36 0 0 1-.487.19.363.363 0 0 1-.197-.473l1.71-3.798.013-.037c.013-.051.324-1.258.089-1.963a2.3 2.3 0 0 0-.615-1.013.24.24 0 0 0-.293-.03l-1.457.906a.37.37 0 0 1-.502-.144.37.37 0 0 1 .147-.504l2.3-1.446q.207-.131.454-.166l1.365-.218a.8.8 0 0 1 .313.041l2.749 1.882a.367.367 0 0 1 .088.515.365.365 0 0 1-.506.096l-2.01-1.389a.24.24 0 0 0-.367.262c.113.409.207.828.278 1.245.05.488.069.984.055 1.474a.24.24 0 0 0 .017.095l.373.942a.74.74 0 0 0 .659.466l1.542.06a.366.366 0 0 1 .01.73"
      />
    </g>
    <defs>
      <clipPath id="kids-teens_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgKidsTeens;
